import { Breadcrumb } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { APP_ROUTES } from 'src/enums';
import { useTheme } from 'src/styles/theme';

import classes from './style/BreadCrumb.module.css';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IBreadCrumbProps {
  exa?: string;
}

const BreadCrumb: React.FunctionComponent<IBreadCrumbProps> = () => {
  // TOOLS
  const { t } = useTranslation();
  const theme = useTheme();

  // PROPS

  // STATE

  // SELECTORS

  const breadcrumbData = [
    { path: '/', breadcrumbName: t('medicalHistory.homePage') },
    {
      path: APP_ROUTES.RELEASE_DOCS,
      breadcrumbName: t('medicalHistory.releaseDoc')
    },
    {
      path: APP_ROUTES.VISIT_SUMMARY,
      breadcrumbName: t('medicalHistory.visitSummary')
    },
    {
      path: APP_ROUTES.ER_SUMMARY,
      breadcrumbName: t('medicalHistory.erSummary')
    },
    {
      path: APP_ROUTES.RADIOLOGY,
      breadcrumbName: t('medicalHistory.radiology')
    },
    { path: APP_ROUTES.LAB, breadcrumbName: t('medicalHistory.lab') }
  ];

  const location = useLocation();
  const breadcrumbItem = breadcrumbData.find(
    (item) => item.path === location.pathname
  );
  // VIEW
  return (
    <>
      <Breadcrumb className={classes.breadCrumbsPath}>
        <Breadcrumb.Item className={theme.fonts.classNames.mainPageUserName}>
          <Link
            to="/"
            className={`${theme.fonts.classNames.mainPageUserName} ${classes.underlineText}`}
          >
            {t('medicalHistory.homePage')}
          </Link>
        </Breadcrumb.Item>
        {breadcrumbItem && (
          <Breadcrumb.Item className={theme.fonts.classNames.mainPageUserName}>
            <Link
              to={breadcrumbItem.path}
              className={theme.fonts.classNames.mainPageUserName}
            >
              {breadcrumbItem.breadcrumbName}
            </Link>
          </Breadcrumb.Item>
        )}
      </Breadcrumb>
      <style>{`
            
            .ant-breadcrumb-separator{
              font-size:${theme.fonts.fontSizes.fontSize14}px
              color:white ;
            }  
              .ant-breadcrumb a{
              color:white ;
              }

           
   `}</style>
    </>
  );
};

export default BreadCrumb;
